module.exports = "//static.hsappstatic.net/ecosystem-marketplace-solutions-base/static-1.6666/img/city-pages-header-image.png"